/*!
script for WooCommerce add to cart with quantity, via AJAX
Author: rmckay@webaware.com.au
Author URI: http://snippets.webaware.com.au/
License: GPLv2 or later
Version: 1.0.1
*/

// @ref: http://snippets.webaware.com.au/snippets/woocommerce-add-to-cart-with-quantity-and-ajax/
// @ref: https://gist.github.com/mikejolley/2793710/

// add this file to folder "js" inside theme

jQuery(function ($) { 
	/* when product quantity changes, update quantity attribute on add-to-cart button */
	if( $( "form.cart" ).length ) {
		$( "form.cart" ).on( "change", ".quantity" , function() {
			if ( this.value === "0" ){
				this.value = "1";
			}
			
			$( this.form ).find( "button[data-quantity]" ).data( "quantity" , this.value );
		} );

		$( "form.cart" ).on( "change", "input.variation_id" , function() {
			$( this.form ).find( "button[data-variation_id]" ).data( "variation_id" , this.value);

			var variation = {};

			$( this.form ).find( 'select[name*="attribute_"]' ).each( function() {
				var attribute_name = $( this ).data( 'attribute_name' ) || $( this ).attr( 'name' );

				if ( $( this ).val().length !== 0 ) {
					variation[ attribute_name ] = $( this ).val();
				}
			} );

			$( this.form ).find( "button[data-variation]" ).data( "variation" , variation );
		} );
	}
} );